import React, { Component } from 'react';
import './dropdown.scss';
import { ImageConstants } from '../../../constants/constants';
import { getImageSource } from '../../../utility/image-source';


class Dropdown extends Component {

    constructor(props) {
        super(props);
        this.state.options = this.props.options ? JSON.parse(JSON.stringify(this.props.options)) : [];

        if (this.props.value) {

            if (this.props.multiple && Array.isArray(this.props.value) && this.props.value.length) {

                let selectedValueHash = {};

                this.state.selectedOptions = this.props.value.map(item => {
                    selectedValueHash[item.title] = item.title;
                    return { title: item.title, value: item.id, isChecked: true }
                });

                for (let i = 0; i < this.state.options.length; i++) {
                    if (selectedValueHash[this.state.options[i].title])
                        this.state.options[i].isChecked = true;
                }
                return;
            }

            let option = [];

            if (this.props.allOptions)
                option = this.props.allOptions.filter(option => option.value == this.props.value);
            else
                option = this.props.options.filter(option => option.value == this.props.value);

            if (option.length)
                this.state.selectedText = option[0].title;
        }
    }

    state = {
        showExpandView: false,
        selectedText: '',
        searchText: '',
        isOptionSelectedAtleastOne: false,
        selectedOptions: []
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.options && JSON.stringify(prevProps.options) !== JSON.stringify(this.props.options)) {
            this.setState({ options: JSON.parse(JSON.stringify(this.props.options)) });
        }
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickEvent, false);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickEvent, false);
    }

    toggleExpandView(value) {
        if (this.props.disabled)
            return;

        this.setState({ showExpandView: value });
    }

    handleClickEvent = (event) => {
        if (this.dropdownRef && !this.dropdownRef.contains(event.target)) {
            if (this.state.showExpandView)
                this.toggleExpandView(false);

            if (this.state.searchText)
                this.resetDropdown();
        }
    }

    onClickOption(option) {
        this.toggleExpandView(false);
        this.setState({ selectedText: option.title });

        if (this.props.searchable)
            this.resetDropdown();

        if (this.props.onSelect)
            this.props.onSelect(option);
    }

    onSearch = (event) => {

        let value = event.target.value;

        this.setState({ searchText: value });

        let origanlOptions = JSON.parse(JSON.stringify(this.props.options));
        let options = origanlOptions.filter(option => option.title.toLowerCase().includes(value.toLowerCase()));
        this.setState({ options: options });

        console.log(event.target.value);
    }

    resetDropdown = () => {
        this.setState({ options: JSON.parse(JSON.stringify(this.props.options)), searchText: '' });
    }

    resetSelectText = _ => {
        this.setState({
            selectedText: ''
        })
    }

    onSelectMultiSelectOption = (option, index) => {

        let options = this.state.options;

        if (option.isChecked)
            options[index].isChecked = false;
        else
            options[index].isChecked = true;

        let optionsTosend = options.filter(option => {
            if (option.isChecked)
                return {
                    title: option.title,
                    value: option.value
                }
        });

        this.setState({ options: options, selectedOptions: optionsTosend });

        if (this.props.onSelect)
            this.props.onSelect(optionsTosend);
    }

    render() {
        return (
            <div className='dropdown' ref={ref => this.dropdownRef = ref}>
                {
                    this.props.searchable ?
                        <input className={`cw-input ${this.state.selectedText ? 'placeholder-selected' : ''} ${this.props.invalid ? 'invalid' : ''}
                                            ${this.props.disabled ? 'disabled-text disabled-placeholder' : ''}`}
                            placeholder={this.state.selectedText ? this.state.selectedText : this.props.placeholder ? this.props.placeholder : ''}
                            onFocus={() => this.toggleExpandView(true)}
                            onChange={this.onSearch}
                            value={this.state.searchText}
                            disabled={this.props.disabled} />

                        :
                        <>
                            {!this.props.multiple ?
                                <div className={`cw-input cursor-pointer selectable-dropdown ${this.props.invalid ? 'invalid' : ''}
                                ${this.props.disabled ? 'disabled-text' : ''}`}
                                    onClick={() => { this.toggleExpandView(true) }}>
                                    {this.state.selectedText ? <span>{this.state.selectedText}</span> : <span className='placeholder'>Select</span>}

                                    <img src={getImageSource(ImageConstants.DOWN_CARET_DROPDOWN)} className='caret'></img>
                                </div>
                                :
                                <div className={`cw-input cursor-pointer selectable-dropdown ${this.props.invalid ? 'invalid' : ''}
                                ${this.props.disabled ? 'disabled-text' : ''}`}
                                    onClick={() => { this.toggleExpandView(true) }}>
                                    {this.state.selectedOptions.length ?
                                        <span>{this.state.selectedOptions.map((option, index) => (<span key={'title' + option.value}>{option.isChecked ? `${option.title}${index != this.state.selectedOptions.length - 1 ? ',' : ''}` : ''}</span>))}</span> :
                                        <span className='placeholder'>Select</span>}

                                    <img src={getImageSource(ImageConstants.DOWN_CARET_DROPDOWN)} className='caret'></img>
                                </div>
                            }
                        </>
                }
                {
                    this.state.options && this.state.options.length && this.state.showExpandView ?
                        <div className='expand-view'>
                            {this.state.options.map((option, index) => (
                                <div key={option.value}>
                                    {
                                        this.props.multiple ?
                                            <div className='name checkbox-alignment' onClick={() => this.onSelectMultiSelectOption(option, index)}>
                                                {/* <label>
                                                    <input type='checkbox' checked={option.isChecked} />
                                                </label> */}
                                                <div className='custom-checkbox'>
                                                    {option.isChecked ? <div className='tick-mark'></div> : ''}
                                                </div>
                                                <span className='chekbox-title'>{option.title}</span>
                                            </div>
                                            :
                                            <div className='name' onClick={() => this.onClickOption(option)}>{option.title}</div>
                                    }
                                </div>
                            ))}
                        </div>
                        : <></>
                }
            </div>);
    }
}

export default Dropdown;